<div #popover class="popover" role="tooltip" [ngClass]="cssClass">
  <div class="popover-arrow" data-popper-arrow></div>
  @if (title) {
    <h3 class="popover-header">
      {{ title }}
    </h3>
  }
  <div class="popover-body">
    <ng-template #container></ng-template>
  </div>
</div>
